import $ from 'jquery';

export default function stickyHeaderModule() {
  const stickyHeaderElement = $('.sticky');
  if (stickyHeaderElement.length) {
    return import(/* webpackChunkName: "stricky-header" */ '../stickyHeader')
      .then(({ default: StrickyHeader }) => {
        const stickyHeader = new StrickyHeader();
        return stickyHeader;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
